import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38bbe47c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=38bbe47c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bbe47c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutAppBar: require('/home/vsts/work/1/s/components/layout/appBar.vue').default,LayoutFooter: require('/home/vsts/work/1/s/components/layout/footer.vue').default})
